__turbopack_context__.v({
  "body": "footer-module__fnqJzq__body",
  "brandmarkIcon": "footer-module__fnqJzq__brandmarkIcon",
  "button": "footer-module__fnqJzq__button",
  "chevronRightSmall": "footer-module__fnqJzq__chevronRightSmall",
  "container": "footer-module__fnqJzq__container",
  "contentGroup": "footer-module__fnqJzq__contentGroup",
  "footer": "footer-module__fnqJzq__footer",
  "footerLink": "footer-module__fnqJzq__footerLink",
  "input": "footer-module__fnqJzq__input",
  "inputContent": "footer-module__fnqJzq__inputContent",
  "linkPrimary": "footer-module__fnqJzq__linkPrimary",
  "links": "footer-module__fnqJzq__links",
  "linksGrid": "footer-module__fnqJzq__linksGrid",
  "logo": "footer-module__fnqJzq__logo",
  "rightColumn": "footer-module__fnqJzq__rightColumn",
  "rightColumnTitle": "footer-module__fnqJzq__rightColumnTitle",
  "social": "footer-module__fnqJzq__social",
  "socialFormTechnologies": "footer-module__fnqJzq__socialFormTechnologies",
  "socialIconLink": "footer-module__fnqJzq__socialIconLink",
  "socialIconWrapper": "footer-module__fnqJzq__socialIconWrapper",
  "title": "footer-module__fnqJzq__title",
  "viewAll": "footer-module__fnqJzq__viewAll",
});
